<script>
export default {
  name: 'ChartLineUp',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="vuesax/bold/diagram">
      <g id="diagram">
        <path
          id="Vector"
          d="M22 22.75H5C2.93 22.75 1.25 21.07 1.25 19V2C1.25 1.59 1.59 1.25 2 1.25C2.41 1.25 2.75 1.59 2.75 2V19C2.75 20.24 3.76 21.25 5 21.25H22C22.41 21.25 22.75 21.59 22.75 22C22.75 22.41 22.41 22.75 22 22.75Z"
          :fill="color"
        />
        <path
          id="Vector_2"
          d="M4.99994 17.7498C4.82994 17.7498 4.64994 17.6898 4.50994 17.5698C4.19994 17.2998 4.15994 16.8298 4.42994 16.5098L9.01994 11.1498C9.51994 10.5698 10.2399 10.2198 10.9999 10.1898C11.7599 10.1698 12.5099 10.4498 13.0499 10.9898L13.9999 11.9398C14.2499 12.1898 14.5699 12.3098 14.9299 12.3098C15.2799 12.2998 15.5999 12.1398 15.8299 11.8698L20.4199 6.50982C20.6899 6.19982 21.1599 6.15982 21.4799 6.42982C21.7899 6.69982 21.8299 7.16982 21.5599 7.48982L16.9699 12.8498C16.4699 13.4298 15.7499 13.7798 14.9899 13.8098C14.2199 13.8298 13.4799 13.5498 12.9399 13.0098L11.9999 12.0598C11.7499 11.8098 11.4199 11.6798 11.0699 11.6898C10.7199 11.6998 10.3999 11.8598 10.1699 12.1298L5.57994 17.4898C5.41994 17.6598 5.20994 17.7498 4.99994 17.7498Z"
          :fill="color"
        />
      </g>
    </g>
  </svg>
</template>
